import { Component, OnInit } from '@angular/core';
import { ModalHerramientasComponent } from './../modal-herramientas/modal-herramientas.component';
import { ModalsService } from './../../../../core/services/modals/modals.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  firstPress: boolean;

  constructor(
    private modalService: ModalsService
  ) { }

  ngOnInit() {
    this.firstPress = false;
  }

  handleFirstPress() {
    this.firstPress = true;
  }

  handleSecondPress() {
    if (this.firstPress) {
      const options = { class: 'modal-tools', initialState: { } };
      this.modalService.openModal(ModalHerramientasComponent, options);
    } else {
      this.firstPress = false;
    }
  }
}
